import React from 'react';
import { Button, Form, Alert } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { TextField } from "../common/FormComponents";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faKey, faSpinner } from '@fortawesome/free-solid-svg-icons';

const validate = values => {
    const errors = {}
    if (!values.username) {
        errors.username = '* Required'
    } else if (values.username.length < 2) {
        errors.username = '* Must be more than 2 characters'
    } else if (values.username === values.email) {
        errors.username = '* Cannot use your email as a username'
    }
    if (!values.email) {
        errors.email = '* Required'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = '* Invalid email address'
    }
    if (!values.password1) {
        errors.password1 = '* Required'
    }
    if (!values.password2) {
        errors.password2 = '* Required'
    } else if (values.password1 !== values.password2) {
        errors.password2 = "* Passwords do not match"
    }
    return errors;
};

const RegisterForm = props => {
    const { handleSubmit } = props;

    return (
        <Form onSubmit={handleSubmit}>
            <div className="adt-flex-container">
                <div className="adt-flex-icon">
                    <FontAwesomeIcon className="text-primary" size="lg" icon={faUser} fixedWidth />
                </div>
                <div className="adt-flex-item">
                    <Field component={TextField}
                        name="username"
                        type="text"
                        label="Username"
                        fullWidth
                        autoFocus
                        onChange={this.handleChange}
                        helperText={<span></span>}
                    />
                </div>
            </div>
            <div className="adt-flex-container">
                <div className="adt-flex-icon">
                    <FontAwesomeIcon className="text-primary" size="lg" icon={faEnvelope} fixedWidth />
                </div>
                <div className="adt-flex-item">
                    <Field component={TextField}
                        name="email"
                        type="email"
                        label="Email"
                        fullWidth
                        onChange={this.handleChange}
                        helperText={<span></span>}
                    />
                </div>
            </div>
            <div className="adt-flex-container">
                <div className="adt-flex-icon">
                    <FontAwesomeIcon className="text-primary" size="lg" icon={faKey} fixedWidth />
                </div>
                <div className="adt-flex-item">
                    <Field component={TextField}
                        name="password1"
                        type="password"
                        label="Password"
                        fullWidth
                        onChange={this.handleChange}
                        helperText={<span></span>}
                    />
                </div>
            </div>
            <div className="adt-flex-container">
                <div className="adt-flex-icon">
                    <FontAwesomeIcon className="text-primary" size="lg" icon={faKey} fixedWidth />
                </div>
                <div className="adt-flex-item">
                    <Field component={TextField}
                        name="password2"
                        type="password"
                        label="Confirm Password"
                        fullWidth
                        onChange={this.handleChange}
                        helperText={<span></span>}
                    />
                </div>
            </div>
            { props.errors ?
                (
                    <div>
                    {props.errors.username ? (<Alert bsStyle="danger">This username is already in use.  Please choose another.</Alert>) : (null)}
                    {props.errors.email ? (<Alert bsStyle="danger">This email address is already in use.</Alert>) : (null) }
                    </div>
                )
                : (null)
            }
            <Button type="submit" disabled={props.pristine || props.pending}>
                {(props.pending) ? (
                <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                ) : ('')}
                Create Account
            </Button>
        </Form>
    )
};

export default reduxForm({ form: 'register', validate, })(RegisterForm)


// WEBPACK FOOTER //
// ./src/Auth/RegisterForm.js